// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".render-breaks{white-space:pre}.filter{display:block}.map-block{height:600px}.classifier-terms{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-flow:wrap;flex-flow:wrap;margin-bottom:0}.classifier-terms .active-tag{padding:5px;border-radius:5px;background-color:#e4e4e4;color:rgba(0,0,0,.6)!important;margin-bottom:5px;margin-right:5px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
